export default "dist/images/block-card-basic.541dc8a.png";